import React from "react";
import { useBNIdentity } from "@gw/bn-identity";
import { LoginForm, Wrapper } from "@gw/component-library";
import { LandingPageStyled } from "./LandingPageStyled";
import { BaseLayout } from "../../layouts";
var LandingPage = function (props) {
    var login = useBNIdentity().login;
    return (React.createElement(BaseLayout, null,
        React.createElement(LandingPageStyled, null,
            React.createElement(Wrapper, { className: "login-wrapper" },
                React.createElement("h1", null,
                    "Welcome to the",
                    React.createElement("br", null),
                    "Seaweed Source!"),
                React.createElement("p", null, "Log in to start connecting with farmers."),
                React.createElement("p", null,
                    "If you don\u2019t have an account, please fill out the",
                    " ",
                    React.createElement("a", { href: "https://greenwave.wufoo.com/forms/m1gkoq4j14wq4t7/", target: "_blank", rel: "noreferrer" }, "application form"),
                    "."),
                React.createElement(LoginForm, { login: login, hideRegister: true, forgotRoute: "/auth/forgot-password", redirectTo: "/directory" })))));
};
export default LandingPage;
//# sourceMappingURL=LandingPage.js.map